import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Holes } from '../../config';
import { getTranslation } from '../../utils/getTranslation';
import ScoreTableRoundStats from './ScoreTableRoundStats';
import { isTeamScoreTeamFormatId } from '../../utils/gameFormatUtils';
import { convertPhcpToString } from '../../utils/convertHcpToString';
export default function ScoreTableRounds(_a) {
    var leaderboard = _a.leaderboard, player = _a.player, roundNumbers = _a.roundNumbers, isTeamGame = _a.isTeamGame, isMultiRound = _a.isMultiRound, viewport = _a.viewport, gameFormatId = _a.gameFormatId, isScratch = _a.isScratch, isWeekly = _a.isWeekly, units = _a.units, timezone = _a.timezone;
    var _b = useState(1), activeRound = _b[0], setActiveRound = _b[1];
    var intl = useIntl();
    var isMobile = viewport.isMobile;
    var getName = function () {
        return player.team === undefined ? player.name : getTeamPlayerNames();
    };
    var getTeamPlayerNames = function () {
        var team = player.team || [];
        return team.map(function (p) { return p.name; }).join(', ');
    };
    var renderRound = function () {
        if (isMobile) {
            return renderMobileRound();
        }
        return renderDesktopRound();
    };
    var renderMobileRound = function () {
        return (React.createElement(React.Fragment, null,
            renderFront9(),
            renderBack9()));
    };
    var renderFront9 = function () {
        var scoreTableRoundHoles = (React.createElement("tr", { className: "score-table-round-holes" },
            React.createElement("th", { className: "w60" }, getTranslation(intl, 'hole')),
            [1, 2, 3, 4, 5, 6, 7, 8, 9].map(function (hole, i) { return (React.createElement("th", { key: i }, hole)); }),
            React.createElement("th", null, getTranslation(intl, 'out')),
            React.createElement("th", null)));
        return render9Holes(scoreTableRoundHoles, Holes.FRONT9);
    };
    var renderBack9 = function () {
        var scoreTableRoundHoles = (React.createElement("tr", { className: "score-table-round-holes" },
            React.createElement("th", { className: "w60" }, getTranslation(intl, 'hole')),
            [10, 11, 12, 13, 14, 15, 16, 17, 18].map(function (hole, i) { return (React.createElement("th", { key: i }, hole)); }),
            React.createElement("th", null, getTranslation(intl, 'in')),
            React.createElement("th", null, getTranslation(intl, 'total'))));
        return render9Holes(scoreTableRoundHoles, Holes.BACK9);
    };
    var render9Holes = function (renderScoreTableRoundHoles, holes) {
        return (React.createElement("table", { className: "score-table-round" },
            React.createElement("thead", null,
                isTeamGame && holes === Holes.FRONT9 && (React.createElement("tr", { className: "score-table-round-player" },
                    React.createElement("th", { colSpan: 23 },
                        getName(),
                        " ",
                        maybeRenderPlayingHcp()))),
                renderScoreTableRoundHoles),
            React.createElement(ScoreTableRoundStats, { leaderboard: leaderboard, player: player, roundNumber: activeRound, isMultiRound: isMultiRound, holesToShow: holes, gameFormatId: gameFormatId, isScratch: isScratch, timezone: timezone })));
    };
    var maybeRenderPlayingHcp = function () {
        var _a;
        var playingHcp = (_a = player.rounds[0]) === null || _a === void 0 ? void 0 : _a.playingHcp;
        var isTeamScoreFormat = gameFormatId && isTeamScoreTeamFormatId(gameFormatId);
        if (!playingHcp || isTeamScoreFormat || isMultiRound) {
            return null;
        }
        return React.createElement("span", null,
            "(",
            convertPhcpToString(playingHcp),
            ")");
    };
    var renderDesktopRound = function () {
        return (React.createElement("table", { className: "score-table-round" },
            React.createElement("thead", null,
                isTeamGame && (React.createElement("tr", { className: "score-table-round-player" },
                    React.createElement("th", { colSpan: 23 },
                        getName(),
                        " ",
                        maybeRenderPlayingHcp()))),
                React.createElement("tr", { className: "score-table-round-holes" },
                    React.createElement("th", { className: "w60" }, getTranslation(intl, 'hole')),
                    [1, 2, 3, 4, 5, 6, 7, 8, 9].map(function (hole, i) { return (React.createElement("th", { key: i }, hole)); }),
                    React.createElement("th", null, getTranslation(intl, 'out')),
                    [10, 11, 12, 13, 14, 15, 16, 17, 18].map(function (hole, i) { return (React.createElement("th", { key: i }, hole)); }),
                    React.createElement("th", null, getTranslation(intl, 'in')),
                    React.createElement("th", null, getTranslation(intl, 'total')))),
            roundNumbers.map(function (roundNumber, i) { return (React.createElement(ScoreTableRoundStats, { key: i, leaderboard: leaderboard, player: player, roundNumber: roundNumber, isMultiRound: isMultiRound, gameFormatId: gameFormatId, isScratch: isScratch, isWeekly: isWeekly, units: units })); })));
    };
    var renderRoundSelectors = function () {
        return (React.createElement(React.Fragment, null, roundNumbers.map(function (roundNumber, i) { return (React.createElement("div", { key: i, onClick: function () { return setActiveRound(roundNumber); }, className: activeRound === roundNumber ? 'active' : '' }, getTranslation(intl, 'round', { round: roundNumber }))); })));
    };
    return (React.createElement("tr", { className: "score-table-expanded" },
        React.createElement("td", { colSpan: 9999, className: "expanded-padding" },
            isMobile && isMultiRound && React.createElement("div", { className: "score-table-mobile-round-selector" }, renderRoundSelectors()),
            renderRound())));
}
